import React from 'react';
interface MobileMockupProps {
  image: string;
  alt: string;
  className?: string;
}
export function MobileMockup({
  image,
  alt,
  className = ''
}: MobileMockupProps) {
  return <div className={`overflow-hidden rounded-[18px] border-[5px] border-ink bg-ink shadow-[0_14px_32px_rgba(14,14,14,0.16)] ${className}`} data-id="element-506" data-mp="2iy89y9ebj4la">
      <div className="mx-auto h-3 w-12 rounded-b-full bg-ink" data-id="element-507" data-mp="2ny4bm1zjmjxo" />
      <div className="overflow-hidden bg-white" data-id="element-508" data-mp="2swnx61a85tpi">
        <img src={image} alt={alt} loading="lazy" decoding="async" className="aspect-[9/16] w-full object-cover object-top" data-id="element-509" data-mp="2svwchli61ge0" />
      </div>
    </div>;
}